import { header, getLanguage, checkFilters } from "./header";

const analytic = header('storage/api/v2/analytics/');

const getAuth = () =>{
    let authorization = localStorage.getItem('auth')
    analytic.defaults.headers.common['Authorization'] =`Bearer ${authorization}` 
}

const setLanguage = () => {
    analytic.defaults.headers.common['Accept-Language'] = getLanguage()
}

export const AnalyticServiceV2 = {
    getFieldsAnalytic(topicsIDs, subtopics, parameters, filters, fields, limit=100, minCount=1, missing=true){
        setLanguage();
        getAuth();
        let subtopicss = subtopics && subtopics.length ? `subtopics/${subtopics.join(",")}/` : '';
        let fieldsTypes = fields.firstField;
        if(fields.secondField) fieldsTypes += '/'+fields.secondField;
        if(fields.thirdField) fieldsTypes += '/'+fields.thirdField;

        const params = {...parameters, ...checkFilters(filters)}
        return analytic.post(`/topics/${topicsIDs}/${subtopicss}${fieldsTypes}?missing=${missing}&limit=${limit}&minCount=${minCount}`, {...params}).then(response => {
            return response.data
        })
    },
}